import {getBaseUrl} from "../../utils";
import io from "../../lib/io";

export async function add(data) {
  return await io.post(`${getBaseUrl()}/admin/teams`, data);
}

export function getAllUrl(queryString) {
  const query = queryString ? `?${queryString}` : '';
  return `${getBaseUrl()}/admin/teams${query}`;
}

export function getAllNationalUrl(queryString) {
  const query = queryString ? `?${queryString}` : '';
  return `${getBaseUrl()}/admin/teams/national${query}`;
}

export function getAllYouthUrl(queryString) {
  const query = queryString ? `?${queryString}` : '';
  return `${getBaseUrl()}/admin/teams/youth${query}`;
}

export function getRemoveUrl(id) {
  return `${getBaseUrl()}/admin/teams/${id}/delete`;
}


export async function getAll() {
  return await io.get(getAllUrl());
}


export async function save(id, data) {
  return await io.post(`${getBaseUrl()}/admin/teams/${id}/edit`, data);
}


export async function getById(id) {
  return await io.get(`${getBaseUrl()}/admin/teams/${id}`);
}


export async function remove(id) {
  return await io.post(getRemoveUrl(id));
}

export async function uploadFile(file) {
  return await io.postFile(`${getBaseUrl()}/uploads/upload_teams_docs_file`, file);
}

export default {
  getAllUrl,
  add,
  getAll,
  save,
  getById,
  remove,
  getRemoveUrl,
  getAllNationalUrl,
  getAllYouthUrl
}
